import "../../pages/App.css";
import { HeaderMain } from "../../components/home/header/Header.js";
import NoticeCard from "../../components/notices/card/NoticeCard.js";

const notices = [
  {
    id: 1,
    title: "EDITAL Nº 01/2025 - SELEÇÃO DE COLABORADORES",
    description: "Processo seletivo para colaboradores voluntários interessados em participar dos Grupos de Estudo Orion em Ciência dos Dados. O objetivo principal é estimular uma reflexão crítica e prática sobre temas atuais e disruptivos, escolhidos semestralmente.",
    startDate: "31/03/2025",
    endDate: "11/04/2025",
    status: "expired",
    buttonText: "Fazer inscrição",
    buttonUrl: "https://docs.google.com/forms/d/e/1FAIpQLSev5zSa_i_CWoX_zimh2c0hYDMzhBW2Te3l-0HiI8sdZBplvQ/viewform?pli=1",
    hasSecondButton: false,
    buttonText2: "Ver edital",
    buttonUrl2: "https://orionufal-my.sharepoint.com/:b:/g/personal/rebeca_queiroz_orion_ufal_br/Eab5DUvqVWZBvoBSznvz-D0B7zqyrls8t_bbleS81D7fDA?e=3E6AKB",
  },
  {id: 2,
    title: "EDITAL Nº 01/2026 - SELEÇÃO DE COLABORADORES",
   description: "Processo seletivo destinado a colaboradores voluntários que desejam participar dos Grupos de Estudo Orion em Ciência dos Dados, desenvolvendo habilidades técnicas e analíticas em temas atuais da área.",
    startDate: "26/01/2026",  
    endDate: "04/02/2026 ",
    status: "expired",
    buttonText: "Inscrever-se",
    buttonUrl: "https://docs.google.com/forms/d/e/1FAIpQLSev5zSa_i_CWoX_zimh2c0hYDMzhBW2Te3l-0HiI8sdZBplvQ/closedform",
    hasSecondButton: false,
    buttonText2: "Ver edital",
    buttonUrl2: "",
    hasThirdButton: true,
    buttonText3: "Resultado final",
    buttonUrl3: "https://drive.google.com/file/d/1Pmgm5Ar1MDEzFXu2MxEETEfEgjZ34mPM/view",
  },
  {id: 3,
    title: "EDITAL Nº 02/2026 - SELEÇÃO DE COLABORADORES",
   description: "Processo seletivo destinado a colaboradores voluntários que desejam participar dos Grupos de Estudo Orion em Ciência dos Dados, desenvolvendo habilidades técnicas e analíticas em temas atuais da área.",
    startDate: "13/08/2026",  
    endDate: "21/08/2026 ",
    status: "expired",
    buttonText: "Inscrever-se",
    buttonUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdMNCLNrf2uPSTnAhBjKXAEM3k2ZAEt9AunYZnCeu-yGkr2JQ/viewform?usp=send_form",
    hasThirdButton: true,
    buttonText3: "Resultado final",
    buttonUrl3: "https://docs.google.com/document/d/1akYiP9SVO-mRFIHbDl_B0Z7kFJSIDTp8K0lYYDjXuyw/edit?usp=sharing",
  }
];

function EditaisPage() {
  return (
    <div
      className="App"
      style={{
        background: "linear-gradient(to bottom right, #6BCF7F 0%, #EFFFEF 20%, #FFFFFF 50%)",
        minHeight: "100vh",
        padding: "0",
      }}
    >
      <HeaderMain />
      <div className="eventContent" style={{ paddingLeft: "35px" }}>
        <h1 style={{ color: "#252B42", fontSize: "36px", textAlign: "left" }}>Editais</h1>
        <p style={{ color: "#374754", fontSize: "18px", textAlign: "left" }}>
        Confira os editais abertos pelo laboratório Orion e participe das nossas seleções para bolsas,<br /> projetos de pesquisa e muito mais.
        </p>

        <div
          style={{
            padding: "30px 30px 30px 0",
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "left",
          }}
        >
          {notices.slice()
  .reverse().map((notice) => (
            <div
              key={notice.id}
              style={{
                flex: "1 1 calc(100% - 16px)",
                boxSizing: "border-box",
                maxWidth: "400px",
              }}
            >
              <NoticeCard
                title={notice.title}
                description={notice.description}
                startDate={notice.startDate}
                endDate={notice.endDate}
                buttonText={notice.buttonText}
                buttonUrl={notice.buttonUrl}
                status={notice.status}
                hasSecondButton={notice.hasSecondButton}
                buttonText2={notice.buttonText2}
                buttonUrl2={notice.buttonUrl2}
                hasThirdButton={notice.hasThirdButton}
                buttonText3={notice.buttonText3}
                buttonUrl3={notice.buttonUrl3}
              />
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
          @media (min-width: 768px) {
            .App > div > div > div {
              flex: 1 1 calc(50% - 16px); /* Em tablets, os cards ocupam 50% */
            }
          }
          @media (min-width: 1024px) {
            .App > div > div > div {
              flex: 1 1 calc(33.33% - 16px); /* Em telas maiores, ocupam 33.33% */
            }
          }
        `}
      </style>
    </div>
  );
}

export default EditaisPage;
